// components/program/EmptyState.jsx
import React from 'react';

const EmptyState = ({ icon, title, subtitle, className = "" }) => {
  return (
    <div className={`text-center text-gray-500 ${className}`}>
      {icon && <p className="text-lg mb-2">{icon}</p>}
      <p>{title}</p>
      {subtitle && <p className="text-sm">{subtitle}</p>}
    </div>
  );
};

export default EmptyState;